import { Link } from "react-router";
import { Globe, ExternalLink, ShieldCheck, MessageCircleMore } from "lucide-react";

const META_CONNECT_PATH = "/settings/integrations/meta-connect";

export default function MessengerConfigPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-6 p-6">
      <div className="space-y-3">
        <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <Globe className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-foreground">Facebook Messenger</h1>
          <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
            Messenger uses the shared Meta connection surface. Connect your Facebook assets there,
            then return here to verify that the channel is mounted for operator use.
          </p>
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-card p-5">
        <div className="flex items-start justify-between gap-4">
          <div className="space-y-2">
            <h2 className="text-base font-semibold text-foreground">Connection path</h2>
            <p className="text-sm text-muted-foreground">
              Use the real Meta settings page to authorize Facebook, review token health, and
              select the connected pages that can power Messenger delivery.
            </p>
          </div>
          <Link
            to={META_CONNECT_PATH}
            className="inline-flex shrink-0 items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Open Meta Connections
            <ExternalLink className="h-4 w-4" />
          </Link>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <section className="rounded-2xl border border-border bg-background p-5">
          <div className="mb-3 flex items-center gap-2 text-foreground">
            <ShieldCheck className="h-4 w-4 text-primary" />
            <h2 className="text-sm font-semibold">What is mounted now</h2>
          </div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>Facebook authorization and token refresh</li>
            <li>Shared Meta page selection for supported channels</li>
            <li>A dedicated Messenger entry in Messaging settings</li>
          </ul>
        </section>

        <section className="rounded-2xl border border-border bg-background p-5">
          <div className="mb-3 flex items-center gap-2 text-foreground">
            <MessageCircleMore className="h-4 w-4 text-primary" />
            <h2 className="text-sm font-semibold">Operational visibility</h2>
          </div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>Messenger conversations land on the canonical facebook_messenger inbox channel</li>
            <li>Delivery and read receipts update outbound message metadata from Meta webhooks</li>
            <li>Operators see receipt state directly in the shared inbox thread</li>
          </ul>
          <Link
            to="/inbox"
            className="mt-4 inline-flex items-center gap-2 rounded-md border border-border px-3 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent"
          >
            Open Inbox
            <ExternalLink className="h-4 w-4" />
          </Link>
        </section>
      </div>
    </div>
  );
}
